<script setup lang="ts">
import { Heading } from "~/components/clarity-ui/Heading";
import SvgIcon from "~/templates/elements/SvgIcon.vue";

export interface FeedbackAreaProps {
  content?: {
    icon?: string; // 'error' | '...'
    headline?: string;
    richText?: string;
  };
}

defineProps<FeedbackAreaProps>();
</script>

<template>
  <div class="flex flex-col items-center gap-4 xl:gap-8">
    <SvgIcon
      v-if="content.icon === 'error'"
      class="h-24 w-24 text-dark-blue"
      name="Error-Circle-Thin"
    />
    <SvgIcon v-else class="h-24 w-24 text-dark-blue" name="Checkmark-Circle-Thin" />
    <Heading v-if="content.headline" class="text-center" color="blue" size="xlarge" tag="h1">
      {{ content.headline }}
    </Heading>
    <div v-if="content?.richText" class="prose" v-html="content?.richText" />
  </div>
</template>
